import { z, isoZ } from 'my-zod'
import { subscriptionPlanMetadata } from './subscription-plan-metadata'
import { MarketEnum } from '../../internal'

/**
 * Each membership market (like Phoenix or Denver etc.)
 * has some values that are specific to it.
 */
export const subscriptionPlanMarketParameters = z.object({
  market: MarketEnum,
  bookingEnabled: z.boolean().describe('True if reservations can be created in this market at this time.'),
  delayStartDate: z.string().optional()
    .describe(`The date a subscription in this market should become active. Allows us to get 
  members enrolled before the market is actually ready to be used.`)
})

export type subscriptionPlanMarketParameters = z.infer<typeof subscriptionPlanMarketParameters>

export const subscriptionPlanModel = z.object({
  id: z.number(),
  name: z.string(),
  metadata: subscriptionPlanMetadata,
  isUnlimited: z.boolean(),
  hasCoupon: z.boolean(),
  isHidden: z
    .boolean()
    .describe('True if this plan should be removed from any list of plans shown in a customer-facing UI.'),
  signupCreditBonus: z.number(),
  subscriptionCreditImpact: z.number(),
  billingProviderProductId: z.string(),
  startDate: isoZ.instant(),
  endDate: isoZ.instant().nullable(),
  creditPurchasePrice: z.number().nullable()
})

export type subscriptionPlanModel = z.infer<typeof subscriptionPlanModel>
